module.exports = __webpack_public_path__ + "@/assets/img/pink.498cd917.jpeg";